/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RotateRequestBody,
  RotateRequestBody$Outbound,
  RotateRequestBody$outboundSchema,
} from "../components/rotaterequestbody.js";

export type RotateInternalSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RotateInternalSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  rotateRequestBody: RotateRequestBody;
};

/** @internal */
export type RotateInternalSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RotateInternalSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  RotateInternalSessionIssuerSecurity$Outbound,
  RotateInternalSessionIssuerSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function rotateInternalSessionIssuerSecurityToJSON(
  rotateInternalSessionIssuerSecurity: RotateInternalSessionIssuerSecurity,
): string {
  return JSON.stringify(
    RotateInternalSessionIssuerSecurity$outboundSchema.parse(
      rotateInternalSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type RotateInternalSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RotateRequestBody: RotateRequestBody$Outbound;
};

/** @internal */
export const RotateInternalSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  RotateInternalSessionIssuerRequest$Outbound,
  RotateInternalSessionIssuerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    rotateRequestBody: RotateRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      rotateRequestBody: "RotateRequestBody",
    });
  }),
);

export function rotateInternalSessionIssuerRequestToJSON(
  rotateInternalSessionIssuerRequest: RotateInternalSessionIssuerRequest,
): string {
  return JSON.stringify(
    RotateInternalSessionIssuerRequest$outboundSchema.parse(
      rotateInternalSessionIssuerRequest,
    ),
  );
}
